export default "__VITE_ASSET__LJDiBeEb__"